import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable } from "rxjs";
import { AppConstants } from "../constants/app.contants";
import { UserService } from "../services/user.service";
@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {
//#region properties
    //#endregion

    //#region ctor
    /**
     *
     */
    constructor(private _userService: UserService, private _router: Router) {}
    //#endregion

    //#region setters
    //#endregion

    //#region getters
    //#endregion

    //#region private actions
    //#endregion

    //#region public actions
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        // Initialize user from localStorage
        this._userService.initializeFromLocalStorage();
        
        // Check if user is authenticated
        if(this._userService.isUserAuthenticated) {
            return true;
        } else {
            // Redirect to login page with return URL
            this._router.navigate([AppConstants.ROUTES.AUTHENTICATION, AppConstants.ROUTES.LOGIN], {
                queryParams: { returnUrl: state.url }
            });
            return false;
        }
    }
    //#endregion
}